import { render, staticRenderFns } from "./CopyStakeAutoclickerView.vue?vue&type=template&id=7475d2e2&scoped=true&lang=pug"
import script from "./CopyStakeAutoclickerView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAutoclickerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7475d2e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
